import { gql } from '@apollo/client';

const ACCOUNT_EXISTS = gql`
  query AccountExists($email: String!) {
    accountExists(email: $email) {
      realmHint
    }
  }
`;

export default ACCOUNT_EXISTS;
